import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import BreachTypeOfEvidenceForm from '../Forms/BreachTypeOfEvidenceForm';

const AddEditBreachTypeOfEvidenceModal = ({
	dataBreachTypeOfEvidence,
	isOpen,
	isEdit,
	handleToggleModal,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Tipo de Evidencia
			</ModalHeader>

			<BreachTypeOfEvidenceForm
				dataBreachTypeOfEvidence={dataBreachTypeOfEvidence}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditBreachTypeOfEvidenceModal;
